(function () {
  function initMaxcalm26TestimonialSlider(section) {
    if (!section || section.dataset.sliderInitialized === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var swiperRoot = section.querySelector('.maxcalm26-testimonials__track');
    if (!swiperRoot) return;

    new Swiper(swiperRoot, {
      slidesPerView: 'auto',
      spaceBetween: 90,
      speed: 450,
      watchOverflow: true,
      grabCursor: true,
      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        989: {
          slidesPerView: 1,
          spaceBetween: 12
        }
      }
    });

    section.dataset.sliderInitialized = 'true';
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-maxcalm26-testimonials]');
    sections.forEach(initMaxcalm26TestimonialSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMaxcalm26TestimonialSlider(event.target);
  });
})();
